export default __webpack_public_path__ + "static/media/480_portfolio02-nl-mobile.f97f4bae.png";